import {
  IntegrationOperationType,
  useIntegrationMetadataContext,
} from 'modules/mobileApps/context/integrationMetadata';
import { ModalType, useModalContext } from 'modules/mobileApps/context/modal';
import { AppPlatform, IntegrationAuthType, IntegrationPlatform } from 'modules/mobileApps/types';
import removeAllSpaces from 'utils/removeAllSpaces';
import { EMPTY_STATE_CONTENT } from '../../../../constants';
import { ConfigureButton, Row } from '../../AssignedIntegrations/AssignedIntegrations.styled';
import {
  EmptyStateContainer,
  GetStartedIcon,
  PrimaryText,
  SecondaryText,
} from '../IntegrationTable.styled';

export const EmptyState = () => {
  const { appDetails, setSelectedIntegration, setOperationType } = useIntegrationMetadataContext();
  const { openModal } = useModalContext();

  const handleClick = () => {
    if (!appDetails) return;

    const defaultFirebaseIntegrationMetadata = {
      authType: IntegrationAuthType.FIREBASE_JSON,
      mobileAppId: appDetails.id,
      mobileAppName: appDetails.name,
      name: removeAllSpaces(appDetails.packageName),
      platform: IntegrationPlatform.GCM,
      projectId: appDetails.projectId,
      testPushSuccess: false,
    };
    setSelectedIntegration(defaultFirebaseIntegrationMetadata);
    setOperationType(IntegrationOperationType.CREATE);
    openModal(ModalType.ConfigureAndroidIntegrationModal);
  };

  switch (appDetails?.platform) {
    case AppPlatform.IOS:
      return (
        <EmptyStateContainer data-test="integration-table-empty-state">
          <GetStartedIcon data-test="integration-table-empty-state-icon" />
          <PrimaryText data-test="integration-table-empty-state-primary-text">
            {EMPTY_STATE_CONTENT.PRIMARY_TEXT}
          </PrimaryText>
          <SecondaryText data-test="integration-table-empty-state-secondary-text">
            {EMPTY_STATE_CONTENT.SECONDARY_TEXT}
          </SecondaryText>
        </EmptyStateContainer>
      );
    case AppPlatform.ANDROID:
      return (
        <Row data-test="integration-table-empty-state-android">
          <div>Firebase</div>
          <div>
            <ConfigureButton
              data-test="integration-table-empty-state-configure-button"
              onClick={handleClick}
            >
              Configure
            </ConfigureButton>
          </div>
        </Row>
      );
    default:
  }
};
